import { SQLModule } from './types';

export const phase3Modules: SQLModule[] = [
  {
    id: "sql-phase3-1",
    title: "Advanced Query Optimization",
    description: "Master advanced query optimization techniques and performance tuning strategies",
    order: 1,
    content: `
# Advanced Query Optimization

## Understanding Query Execution Plans
Learn to read and interpret execution plans to identify performance bottlenecks.

## Index Optimization Strategies
Master the art of creating and maintaining optimal indexes for query performance.

## Query Rewriting Techniques
Transform slow queries into high-performance alternatives while maintaining correctness.
    `,
    estimatedTime: 90,
    duration: "90 minutes",
    difficulty: "advanced",
    prerequisites: ["Intermediate SQL knowledge", "Understanding of database architecture"],
    tags: ["optimization", "performance", "indexes", "execution-plans"]
  },
  {
    id: "sql-phase3-2",
    title: "Database Security Best Practices",
    description: "Implement robust security measures to protect sensitive data",
    order: 2,
    content: `
# Database Security Best Practices

## Authentication and Authorization
Secure database access with strong authentication and fine-grained authorization controls.

## Encryption Techniques
Protect data at rest and in transit with encryption.

## Auditing and Compliance
Implement auditing mechanisms to track database activity and ensure compliance.
    `,
    estimatedTime: 80,
    duration: "80 minutes",
    difficulty: "advanced",
    prerequisites: ["Intermediate SQL knowledge", "Understanding of security principles"],
    tags: ["security", "authentication", "encryption", "auditing"]
  },
  {
    id: "sql-phase3-3",
    title: "High Availability and Disaster Recovery",
    description: "Design and implement strategies for ensuring continuous database availability",
    order: 3,
    content: `
# High Availability and Disaster Recovery

## Replication Strategies
Implement replication to maintain multiple copies of data for redundancy.

## Failover Mechanisms
Design automatic failover systems to minimize downtime.

## Backup and Recovery Procedures
Establish robust backup and recovery procedures to protect against data loss.
    `,
    estimatedTime: 100,
    duration: "100 minutes",
    difficulty: "expert",
    prerequisites: ["Advanced SQL knowledge", "Database administration experience"],
    tags: ["high-availability", "disaster-recovery", "replication", "failover"]
  }
];
